module.exports = __webpack_public_path__ + "img/mise-en-qualite-24px-outline.bd945eaa.svg";